<template>
    <section>
        <b-field grouped group-multiline>
            <b-select v-model="perPage" @input="getData">
                <option value="5">5 por página</option>
                <option value="10">10 por página</option>
                <option value="15">15 por página</option>
                <option value="20">20 por página</option>
            </b-select>

        </b-field>
        <b-table
        :data="data"
        paginated
        :loading="loading"
        :per-page="perPage"
        backend-pagination
        default-sort="id"
        backend-sorting
        :current-page="currentPage"
        :total="total"
        @sort="sorted"
        @page-change="pageChange">

        <template slot-scope="props">
            <b-table-column label="Acciones">
                <action-buttons :row="props.row" primary-key="uuid" show  model="Calls">
                    <template slot-scope="item">
                        <show-call :item="item.item"></show-call>
                    </template>
                </action-buttons>
            </b-table-column>
            <b-table-column field="id" label="ID" width="40" sortable numeric>
                {{ props.row.id }}
            </b-table-column>

            <b-table-column field="from" label="Numero entrante" sortable>
                {{ props.row.from }}
            </b-table-column>
            <b-table-column field="to" label="Operadora" sortable>
                {{ props.row.to}}
            </b-table-column>
            <b-table-column field="answered_poll_at" label="Fecha entrada" sortable>
                {{ props.row.answered_poll_at | date}}
            </b-table-column>
            <b-table-column field="answered_poll_at_time" label="Inicó" sortable>
                {{ props.row.answered_poll_at | time}}
            </b-table-column>
            <b-table-column field="finished_at" label="Terminó" sortable>
                {{ props.row.finished_at | time}}
            </b-table-column>
            <b-table-column field="duration" label="Duración" sortable>
                {{ props.row.answered_poll_at| Duration(props.row.finished_at)}}
            </b-table-column>
            <b-table-column field="status" label="Status">
                <span  v-html="$options.filters['status'](props.row.status)">
                </span>
            </b-table-column>
        </template>
    </b-table>
</section>
</template>

<script>
    import LaravelEcho from 'laravel-echo'

    export default {
        data() {
            return {
                data: [

                ],
                currentPage: 1,
                perPage: 10,
                total: 0,
                order: 'desc',
                field: 'id',
                loading: false
            }
        },
        created() {
            this.prepareComponent()
        },
        destroyed() {
            this.echo.leave('Calls');
        },
        methods: {
            prepareComponent() {
                const echo = new LaravelEcho(this.$backend.socketHeaders())
                this.getData()
                echo.private('Calls').listen('\\App\\Events\\Ivr\\NewCallEvent', e => {
                    this.getData()
                })
            },
            sorted(field, order) {
                this.field = field;
                this.order = order;
                this.getData()
            },
            pageChange(page) {
                this.currentPage = page;
                this.getData()
            },
            getData() {
                this.loading = true
                this.$http.get('ivr/calls', {
                    params: {
                        pagesize: this.perPage,
                        page: this.currentPage,
                        field: this.field,
                        sorting: this.order,
                    }
                }).then(response => {
                    this.loading = false;
                    let res = response.data;
                    this.data = res.data;
                    this.total = res.total
                }, error => {
                    this.loading = false;
                    Toast.danger(error.response.data.message)
                })
            }
        }
    }
</script>
